
import { supabase } from '@/integrations/supabase/client';

export const seedSeoData = async () => {
  const sampleSeoSettings = [
    {
      page_type: 'home',
      page_identifier: null,
      meta_title: 'GameHub - Free Online Games for Everyone',
      meta_description: 'Play thousands of free online games at GameHub. From action to puzzle games, we have something for everyone. No downloads required!',
      meta_keywords: 'free games, online games, web games, browser games, action games, puzzle games',
      og_title: 'GameHub - Your Ultimate Gaming Destination',
      og_description: 'Discover and play amazing free games online. Join millions of players at GameHub!',
      og_image: 'https://gamehub.com/images/og-home.jpg'
    },
    {
      page_type: 'category',
      page_identifier: 'action',
      meta_title: 'Action Games - Fast-Paced Gaming at GameHub',
      meta_description: 'Experience heart-pounding action games at GameHub. Fight, race, and survive in our collection of thrilling action games.',
      meta_keywords: 'action games, fighting games, racing games, adventure games, shooter games',
      og_title: 'Action Games Collection - GameHub',
      og_description: 'Get your adrenaline pumping with our amazing action games collection!',
      og_image: 'https://gamehub.com/images/og-action.jpg'
    }
  ];

  try {
    const { error } = await supabase
      .from('seo_settings')
      .insert(sampleSeoSettings);
    
    if (error) {
      console.error('Error seeding SEO data:', error);
      throw error;
    }
    
    console.log('SEO data seeded successfully');
  } catch (error) {
    console.error('Failed to seed SEO data:', error);
  }
};
